import { render, staticRenderFns } from "./LeftTree.vue?vue&type=template&id=72d0241c&scoped=true&"
import script from "./LeftTree.vue?vue&type=script&lang=ts&"
export * from "./LeftTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d0241c",
  null
  
)

export default component.exports